import React, { Fragment, useEffect, useState } from "react";
import { addDays } from "date-fns";
import { format } from "date-fns";
import { getXYChartKeyOptions } from "../../../utilities/Charts/getKeyOptions";
import LoadingDots from "../../../LoadingDots/LoadingDots";
import Graph from "../../../Graph/Graph";
import FeedTotals from "@solarschools/component-lib/components/FeedTotals";

const dataKeys = [
  "solarConsumed",
  "solarFeedIn",
  "gridConsumed",
  "solarGenerated",
  "netConsumed",
];

export const GridVMGraph = ({
  gridVMs,
  selectedGridVMIndex,
  api,
  startDate,
  selectionCallback,
  isKW,
  endDate,
}) => {
  const [gridVMData, setGridVMData] = useState();
  const start = format(startDate, "yyyy-MM-dd");
  const end = format(addDays(endDate, 1), "yyyy-MM-dd");

  const loadData = async () => {
    // if gridVMs
    if (gridVMs[selectedGridVMIndex] && gridVMs[selectedGridVMIndex].id) {
      try {
        const data = await api.call("data", "getEnergyFeed", [
          "gridtree",
          gridVMs[selectedGridVMIndex].id,
          start,
          end,
          undefined,
          true,
        ]);
        setGridVMData(data);
      } catch (error) {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    (async () => {
      if (gridVMs[selectedGridVMIndex]) {
        await loadData();
      }
    })();
  }, [gridVMs, selectedGridVMIndex]);

  return (
    <div>
      {!gridVMData ? (
        <div className="aspect-ratio aspect-ratio-30by10">
          <div className="aspect-ratio-content text-center d-flex flex-column justify-content-center align-items-center">
            <LoadingDots spinnerClass="bg-primary" />
          </div>
        </div>
      ) : (
        <Fragment>
          <Graph
            hideScroll
            data={gridVMData.data}
            totals={gridVMData.totals}
            aggregation={gridVMData.aggregation}
            selectionCallback={selectionCallback}
            keyOptions={getXYChartKeyOptions()}
            dataKeys={dataKeys}
            forceKw={isKW}
          />
          <div className="d-flex flex-column w-100 h-100 p-2">
            {gridVMData.totals && (
              <FeedTotals data={gridVMData.totals} hasCapacity={true} />
            )}
          </div>
        </Fragment>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/components/GridVMGraph/GridVMGraph.js